import LocalStoreManager from "./local-store-manager";
// Proxies
import GetCompanyProxy from "../proxies/back-end/company/get";
import UserCompanyUsersProxy from "../proxies/back-end/users/user-company-users";

// Constants
import { uniq } from "lodash";

import { Constants } from "customer-sdk/constants";
const { SLEEK_APP_CACHE_KEY } = Constants.STORE_CONSTANTS;
const PAGE_URLS = Constants.PAGE_URLS;
const COMPANY_STATUSES = Constants.COMPANY_STATUSES;
const { COMPANY_USER_MODULE, COMPANY_USERS }  = Constants.COMPANY_USERS_CONSTANTS;

const store = new LocalStoreManager();
const {
  PARTNER_PAID,
  PROCESSING_BY_SLEEK,
  REFERRED_TO_ACRA,
  LIVE_POST_INCORPORATION,
  PAID_AND_INCOMPLETE,
  PROCESSING_INCORP_TRANSFER,
  LIVE,
} = COMPANY_STATUSES;
const partnerRoutes = [PAGE_URLS.HOME, PAGE_URLS.INVITATION, PAGE_URLS.PROFILE];
const routesForPartnerUserOnly = [
  PAGE_URLS.HOME,
  PAGE_URLS.PARTNERS,
  PAGE_URLS.ENQUIRY,
  PAGE_URLS.PARTNERS,
  PAGE_URLS.PAYMENT_PROCESSING,
  PAGE_URLS.VERIFY,
  PAGE_URLS.PROFILE,
  PAGE_URLS.VERIFY_ACCOUNT,
  PAGE_URLS.PARTNER.INDEX,
  PAGE_URLS.PARTNER.BILLING_PROFILE,
  PAGE_URLS.PARTNER.TRANSACTIONS,
  PAGE_URLS.PARTNER.ONBOARDING,
  PAGE_URLS.PARTNER.COMPANY_SETUP,
  PAGE_URLS.PARTNER.CORP_SEC,
];
const { pathname } = window.location;
/**
 * @class DefaultRouteEngine
 * @description Class used for asserting the route for any user in Partner.
 * @author Rock Pineda
 * @version 1.0
 * @since June 4, 2020
 */

/*eslint complexity: "off"*/
export default class PartnerRouteService {
  /**
   * @async
   * @function routePartner
   * @description Method used for executing the module.
   */
  /*eslint-disable */
  async routePartner(component, payload, options = {}) {
    let proxy = new GetCompanyProxy();
    let company = null;
    if(payload && payload.id) {
      company = await proxy.execute(payload);
    }
    

    if (company) {

      let companyUsers = [];

      if (component) {
        companyUsers = component.$store.getters[`${COMPANY_USER_MODULE}/${COMPANY_USERS}`];
      } else {
        const sleekAppCacheKey = await localStorage.getItem(SLEEK_APP_CACHE_KEY) || [];
        if (sleekAppCacheKey) {
          if (sleekAppCacheKey.length > 0) {
            let parsedSleekAppCache = JSON.parse(sleekAppCacheKey);
            if (parsedSleekAppCache && parsedSleekAppCache.companyUsersModule && parsedSleekAppCache.companyUsersModule.companyUsers) {
              companyUsers = parsedSleekAppCache.companyUsersModule.companyUsers;
            }
          }
        } else {
          store.logout();
        }
      }
      let userId = await store.getUserId();
      let companyId = await store.getCompanyId();
      let companyOwner = companyUsers.filter(companyUser => companyUser.company === companyId && companyUser.user._id === userId && companyUser.is_owner);

      if(options && options.isFromLogin) {

        let userCompanyUsers = await UserCompanyUsersProxy.getUserCompanyUsers({
          userId: userId,
          authToken: store.getToken()
        });

        const isACompanyOwnerAtleastOnce = userCompanyUsers.filter(companyUser => companyUser.user === userId && companyUser.is_owner);
        let companiesOfUser = isACompanyOwnerAtleastOnce.map(companyUser => companyUser.company._id);
        companiesOfUser = uniq(companiesOfUser);
        if(companiesOfUser.length === 1 && isACompanyOwnerAtleastOnce.length === 1) {
          return PAGE_URLS.HOME;
        }
        if (isACompanyOwnerAtleastOnce.length > 0) {
          return `${PAGE_URLS.PARTNER.VIEW_ALL_COMPANIES}`;
        }
      }

      if (companyOwner.length > 0 && [PARTNER_PAID.value, PAID_AND_INCOMPLETE.value, PROCESSING_BY_SLEEK.value, PROCESSING_INCORP_TRANSFER.value, REFERRED_TO_ACRA.value, LIVE_POST_INCORPORATION.value, LIVE.value].includes(company.status) && !company.is_dashboard_launched && !(company.is_transfer && company.status == LIVE.value)) {
        return `${PAGE_URLS.PARTNER.COMPANY_SETUP}?cid=${payload.id}`;
      } else if (companyOwner.length === 0 && !store.getIsAdmin() && !partnerRoutes.includes(pathname)) {
        return PAGE_URLS.HOME;
      } else if (!routesForPartnerUserOnly.includes(pathname)) {
        return PAGE_URLS.HOME;
      }
    }
    return PAGE_URLS.HOME;
  }
}